import { FEATURE_FLAGS } from '../../../../featureFlags';
import KnowledgeBases from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/knowledge-bases'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'knowledge_bases',
          component: KnowledgeBases,
          meta: {
            featureFlag: FEATURE_FLAGS.CAPTAIN,
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
  ],
};
